import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { hot } from "react-hot-loader";
import { Transition, TransitionGroup } from "react-transition-group";
import _ from "lodash";
import moment from "moment";
import {
    selectWeekCount,
    selectRowCount,
    selectArrangedJobpostingsAsArray,
    selectSelectedJobpostingID,
    selectRawJobpostings,
    selectEvents,
} from "./selectors";
import Event from "./Event";

const EventRowContainer = styled.div`
    grid-row-start: 1;
    grid-row-end: 1;
    grid-column-start: 1;
    grid-column-end: ${(props) => props.weekCount * 7 + 2};
    box-sizing: border-box;
    position: relative;
    pointer-events: none;
`;

class EventsContainer extends React.Component {
    getRowCount = () => {
        if (this.props.arrangedJobpostingsAsArray.length > 0) {
            let postings = _.compact(
                this.props.arrangedJobpostingsAsArray.map((e, i) => {
                    if (this.props.events[e.uid])
                        return this.props.events[e.uid].track_id ===
                            this.props.track_id
                            ? e
                            : null;
                    else return null;
                })
            );

            if (postings.length < 1) return 1;
            let obj = {};
            let countArr = postings.map((e) => {
                let fEvent = this.props.events[e.uid];

                let count = 1;
                postings.map((f) => {
                    let sEvent = this.props.events[f.uid];
                    if (
                        e.uid !== f.uid &&
                        this.isOverlapping(
                            fEvent.start_date,
                            fEvent.end_date,
                            sEvent.start_date,
                            sEvent.end_date
                        )
                    ) {
                        let ob = obj[e.uid] || [];
                        ob.push(f.uid);

                        obj = { ...obj, [e.uid]: ob };
                        count++;
                    }
                    return null;
                });
                if (obj[e.uid]) {
                }
                return count;
            });
            let reduced = {};
            let redCount = false;
            Object.keys(obj).map((e) => {
                if (obj[e].length > 1) {
                    reduced = { ...reduced, [e]: obj[e] };
                }
                return null;
            });
            Object.keys(reduced).map((e) => {
                reduced[e].map((r) => {
                    let fEvent = this.props.events[r];
                    reduced[e].map((d) => {
                        let sEvent = this.props.events[d];

                        if (
                            d !== r &&
                            !this.isOverlapping(
                                fEvent.start_date,
                                fEvent.end_date,
                                sEvent.start_date,
                                sEvent.end_date
                            )
                        )
                            redCount = true;

                        return null;
                    });
                    return null;
                });
                return null;
            });
            let rows = Math.max.apply(Math, countArr);

            return redCount ? rows - 1 : rows;
        } else return 0;
    };
    isOverlapping(fStart, fEnd, sStart, sEnd) {
        let format = "DD-MM-YYYY";
        if (fStart && fEnd && sStart && sEnd) {
            fStart = moment(fStart, format).startOf("day");
            fEnd = moment(fEnd, format).endOf("day");
            sStart = moment(sStart, format).startOf("day");
            sEnd = moment(sEnd, format).endOf("day");
            if (
                sStart.isBetween(fStart, fEnd, undefined, "[]") ||
                sEnd.isBetween(fStart, fEnd, undefined, "[]") ||
                fStart.isBetween(sStart, sEnd, undefined, "[]") ||
                fEnd.isBetween(sStart, sEnd, undefined, "[]") ||
                (sStart.isBetween(fStart, fEnd, undefined, "[]") &&
                    sEnd.isBetween(fStart, fEnd, undefined, "[]"))
            )
                return true;
            else return false;
        } else return false;
    }
    getRowIndex = (uid) => {
        let event = this.props.events[uid];
        let index = 1;
        let maxRow = this.getRowCount();

        let postings = _.compact(
            this.props.arrangedJobpostingsAsArray.map((e, i) => {
                if (this.props.events[e.uid])
                    return this.props.events[e.uid].track_id ===
                        this.props.track_id
                        ? e
                        : null;
                return null;
            })
        );

        let actualRows = _.compact(
            postings.map((e, i) => {
                let currEvent = this.props.events[e.uid];
                if (event && currEvent) {
                    if (
                        this.isOverlapping(
                            event.start_date,
                            event.end_date,
                            currEvent.start_date,
                            currEvent.end_date
                        )
                    ) {
                        return e;
                    }
                } else return null;
                return null;
            })
        );
        if (maxRow === 1) {
            return 0;
        }
        if (actualRows.length === 1) {
            return 0;
        }

        actualRows.map((e, i) => {
            if (e.uid === uid) {
                index = i;
            }
            return null;
        });

        return index === maxRow ? maxRow - 1 : index;
    };
    render() {
        const {
            duration,
            arrangedJobpostingsAsArray,
            weekCount,
            selectedJobpostingID,
        } = this.props;

        return (
            <EventRowContainer weekCount={weekCount}>
                <TransitionGroup component={null}>
                    {_.compact(
                        arrangedJobpostingsAsArray.map((e, i) => {
                            if (this.props.events[e.uid]) {
                                if (
                                    this.props.events[e.uid].track_id ===
                                    this.props.track_id
                                ) {
                                    return (
                                        <Transition
                                            key={i}
                                            appear
                                            timeout={duration}
                                        >
                                            {(transitionStatus) => {
                                                return (
                                                    <Event
                                                        track_id={
                                                            this.props.track_id
                                                        }
                                                        key={i}
                                                        event={e}
                                                        weekCount={weekCount}
                                                        rowCount={this.getRowCount()}
                                                        duration={duration}
                                                        editEvent={
                                                            this.props.editEvent
                                                        }
                                                        transitionStatus={
                                                            transitionStatus
                                                        }
                                                        rowIndex={this.getRowIndex(
                                                            e.uid
                                                        )}
                                                        selected={
                                                            e.uid ===
                                                            selectedJobpostingID
                                                        }
                                                        eventInfo={
                                                            this.props.events[
                                                                e.uid
                                                            ] || {}
                                                        }
                                                    />
                                                );
                                            }}
                                        </Transition>
                                    );
                                }
                            }
                            return null;
                        })
                    )}
                </TransitionGroup>
            </EventRowContainer>
        );
    }
}

export default hot(module)(
    React.memo(
        connect((store, props) => {
            return {
                weekCount: selectWeekCount(store),
                rowCount: selectRowCount(store),
                arrangedJobpostingsAsArray: selectArrangedJobpostingsAsArray(
                    store
                ),
                selectedJobpostingID: selectSelectedJobpostingID(store),
                jobpostings: selectRawJobpostings(store),
                events: selectEvents(store),
            };
        }, {})(EventsContainer)
    )
);
